var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6565;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.87,326.58l-61.39-53.73L18.95,423.32c6.39,5.92,15,9.61,24.49,9.61h424.87c9.46,0,18.04-3.68,24.38-9.61 L317.27,272.85L255.87,326.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.8,88.06c-6.39-5.96-14.96-9.61-24.49-9.61H43.44c-9.46,0-18.04,3.69-24.42,9.68l236.86,203.01 L492.8,88.06z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.75,109.58 7.75,404.07 179.06,258.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.68,258.49 504,404.07 504,109.47  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.601d9c4f636a65116192058c59d2d2f8.svg";
export { ForwardRef as ReactComponent };